export default "__VITE_ASSET__63288a91__"